import * as Yup from "yup";
import checkout from "./Form";

const {
  formField: {
    // datas
    number,
		name,
		regional,
  },
} = checkout;

// eslint-disable-next-line import/no-anonymous-default-export
export default [
  // datas
  Yup.object().shape({
    [number.name]: Yup.string()
    .matches(/^\d+$/, "O campo Número só aceita números")
    .required(number.errorMsg),
    [name.name]: Yup.string().required(name.errorMsg),
    [regional.name]: Yup.string().required(regional.errorMsg),
  }),
];